import React, { createContext, useContext } from 'react'

const ApolloAllLanguagesClientContext = createContext()
export const useApolloAllLanguagesClient = () => useContext(ApolloAllLanguagesClientContext)

export function ApolloAllLanguagesClientProvider({ client, children }) {
  return <ApolloAllLanguagesClientContext.Provider value={client}>{children}</ApolloAllLanguagesClientContext.Provider>
}
